<template>
  <div>
    <p id="allRegions" v-show="regionClicked!='ALL REGIONS'" v-on:click="locationClicked = 'all-regions';regionClicked = 'ALL REGIONS';">ALL REGIONS</p>
    <highmaps :options="chartOptions" ref="highcharts"></highmaps>
    <el-col :span="20" :offset="1">
      <app-oven :regionClicked="regionClicked"
                :locationClicked="locationClicked"
                :regionsColors="regionsColors"
                :loadingDone="loadingDone"></app-oven>
    </el-col>
  </div>
</template>

<script>
  import Element from 'element-ui';
  import axios from 'axios';
  import HighCharts from 'vue-highcharts';
  import json from '../map.json'

    let legend = true;

    export default {
    data: function () {
      return {
        regionClicked: 'ALL REGIONS',
        locationClicked: 'all-regions',
        regionsColors: [],
        loadingDone: false,
        /* Map */
        chartOptions: {

          chart: {
            height: (window.innerHeight-((window.innerHeight*18)/100)),
            map: json, // The map data is taken from the .json file imported above
          },
          title: {
            text: ''
          },
          legend: {
            enabled: legend,
          },

          plotOptions: {
            series: {
              point: {
                events: {
                  click: (e) => {
                    this.regionClicked = e.point.name;
                    this.locationClicked = e.point.code;
                  }
                }
              }
            },
            map: {
              /* hc-a2 is the specific code used, you can find all codes in the map.json file */
              joinBy: ['hc-key', 'code'],
              allAreas: false,
              tooltip: {
                headerFormat: '',
                pointFormat: "<b>{point.name}</b>",
              },
            }
          },
          /* Zoom and move */
          mapNavigation: {
            enabled: true,
            buttonOptions: {
              style: {"display": "none"},
            }
          },
          /* Disable bottom-right credits */
          credits: {
            enabled: false,
          },
          series: [
            /* This part is needed because otherwise each series will overwrite the one before it */
            {
              allAreas: true,
              showInLegend: false,
            },
          ],
        }
      }
    },
    methods:{
      uniqueDevices(deviceList) {
        let seen = {};
        return deviceList.filter(function(item) {
          return seen.hasOwnProperty(item.deviceName) ? false : (seen[item.deviceName] = true);
        });
      }
    },
    created: function () {
      if(this.$cookie.get('user') === null)
        this.$router.push('/')
    },
    mounted: function(){
      let app = this;
      let okRegions = []
      let warningRegions = []
      let errorRegions = []
      let chart = app.$refs.highcharts.chart;

      /* If the device is small then it doesn't show some elements */
      if(window.innerWidth <= 768) {
        legend = false;
      }

      axios.post(`https://iiot.dave.eu/api/genericQuery`, {
        query: "SELECT * FROM device, location, statistics WHERE device.deviceLocation=location.id AND statistics.device=device.id ORDER BY statistics.id_statistics DESC;"
      }).then(function (response) {
        let devicesList = app.uniqueDevices(response.data)
        app.regionsColors = devicesList;
        /* Add all the possible locations, sorting based on status */
        devicesList.forEach(function (device) {
          if(device.status === "OK")
            okRegions.push(device.code)
          else if (device.status === "WARNING")
            warningRegions.push(device.code)
          else
            errorRegions.push(device.code)
        });

        chart.addSeries({
            borderColor: '#9b3737',
            cursor: 'pointer',
            name: 'CRITICAL',
            color: "#ef4d4d",
            data: errorRegions.map(function (code) {
              return {code: code};
            })
          });
        chart.addSeries({
            borderColor: '#9b7f37',
            cursor: 'pointer',
            name: 'WARNING',
            color: "#eaca44",
            data: warningRegions.map(function (code) {
              return {code: code};
            })
          });
        chart.addSeries({
            borderColor: '#659b51',
            cursor: 'pointer',
            name: 'OK',
            color: "#80b855",
            data: okRegions.map(function (code) {
              return {code: code};
            })
          });
          app.loadingDone = true;
        }).catch(function (error){
        console.error("Download Devices ERROR: " + error.response.data.message);
      })
    }
  }
</script>

<style scoped>
  /* Tablets and smaller */
  @media only screen and (max-width: 768px) {
    #allRegions {
      background-color: rgba(204, 204, 204, 0.2);
      display: inline-block;
      position: absolute;
      z-index: 10;
      left: 10%;
      padding: 5px;
      border-radius: 10px;
      box-shadow: rgba(0, 0, 0, 0.12) 0 1px 6px, rgba(0, 0, 0, 0.12) 0 1px 4px;
      transition: .15s all ease-out;
    }
    #deviceContainer{

      position: inherit;
    }
    .highcharts-legend{
      display: none;
    }
  }

  /* Bigged then a tablet */
  @media only screen and (min-width: 768px) {
    #allRegions {
      background-color: rgba(204, 204, 204, 0.2);
      display: inline-block;
      position: absolute;
      z-index: 10;
      left: 10%;
      padding: 5px;
      border-radius: 10px;
      box-shadow: rgba(0, 0, 0, 0.12) 0 1px 6px, rgba(0, 0, 0, 0.12) 0 1px 4px;
      transition: .15s all ease-out;
    }

    #allRegions:hover {
      cursor: pointer;
      transform: scale(1.1);
    }

    #deviceContainer {
      position: fixed;
      right: 2%;
      top: 90px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Index.vue